import { compactNumber, type ChartPoint, type MetricDisplayKind } from "./record-dashboard-model";

export function chartPointSeriesSummary(
  title: string,
  points: ChartPoint[],
  displayKind: MetricDisplayKind,
): string {
  if (points.length === 0) return `${title}. No data points.`;
  const latest = points.at(-1)!;
  let minimum = points[0]!;
  let maximum = points[0]!;
  for (const point of points.slice(1)) {
    if (point.value < minimum.value) minimum = point;
    if (point.value > maximum.value) maximum = point;
  }
  return [
    `${title}. ${points.length} data ${points.length === 1 ? "point" : "points"}.`,
    `Latest ${latest.label}: ${compactNumber(latest.value, displayKind)}.`,
    `Range ${compactNumber(minimum.value, displayKind)} to ${compactNumber(maximum.value, displayKind)}.`,
  ].join(" ");
}

export function chartPointCategorySummary(
  title: string,
  points: ChartPoint[],
  displayKind: MetricDisplayKind,
  additive = true,
): string {
  if (points.length === 0) return `${title}. No categories.`;
  let largest = points[0]!;
  let total = 0;
  for (const point of points) {
    total += point.value;
    if (point.value > largest.value) largest = point;
  }
  return [
    `${title}. ${points.length} ${points.length === 1 ? "category" : "categories"}.`,
    `Largest ${largest.label}: ${compactNumber(largest.value, displayKind)}.`,
    // Summing averages/minimums/maximums would misinform screen-reader users.
    ...(additive ? [`Total ${compactNumber(total, displayKind)}.`] : []),
  ].join(" ");
}
